module.exports = __webpack_public_path__ + "static/media/POP.000005a6.svg";